<template>
 <header>
    <h1>
     Top {{ nbGames > 0 ? nbGames : '' }} Free Games (US)
    </h1>
 </header>
</template>

<style>
h1 {
  text-align: center;
  margin: 10px auto;
}
</style>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      activeIndex: '/',
    };
  },
  computed: {
    ...mapGetters({ nbGames: 'game/nbGames' }),
  },
};
</script>
